import React from 'react';

import {connect} from 'react-redux';

import axiosMethods from '@/api/apiManager';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';

import './AllHardwareValue.css';

const timingUpdate = 2000;

const tempAllSensor = {
  AA: {
    A: 'asd',
    B: 'ajs',
    C: 'aknd',
  },
  BB: {
    A: 'sdf',
    B: 'gss',
    C: 'fdss',
  },
  CC: {
    A: 'ijq',
    B: 'cba',
    C: 'jqwd',
  },
  DD: {
    A: 'QQQQ',
    B: 'DDD',
    C: 'SSSS',
  },
};

@connect((store) => ({
  hardwareList: store.modalStore.hardwareList,
}))
class ManualHardwareCheck extends React.Component {
  constructor(props) {
    super(props);

    this.getSensorValue = this.getSensorValue.bind(this);
  }

  componentDidMount() {
    this._statusServicePooling = setInterval(() => {
      this.getSensorValue();
    }, timingUpdate);
  }

  componentWillUnmount() {
    if (typeof this._statusServicePooling !== 'undefined') clearInterval(this._statusServicePooling);
  }

  // eslint-disable-next-line class-methods-use-this
  getSensorValue() {
    axiosMethods.get(APPDATA.API.GET_ALL_SENSOR).then((response) => {
      consoleLog(response);
    });
  }

  render() {
    const allSensorShow =
      tempAllSensor !== null
        ? Object.keys(tempAllSensor).map((name) =>
            Object.keys(tempAllSensor[name]).map((sensorName) => (
              <div className="row remove_margin">
                <span>
                  {' '}
                  {name} : {sensorName} : {tempAllSensor[name][sensorName]}
                </span>
              </div>
            )),
          )
        : false;
    return <div className="row active-scroll-bar_hardware-value">{allSensorShow}</div>;
  }
}
export default ManualHardwareCheck;
